import { useT } from '../i18n/context'
import { useUiStore } from '../stores/ui'

/** DE|EN Segmented-Control — gesetzt in Topbar, Mobile-Menü und Login. */
export function LanguageToggle({ className = '' }: { className?: string }) {
    const t = useT()
    const language = useUiStore(s => s.language)
    const setLanguage = useUiStore(s => s.setLanguage)

    return (
        <div
            className={`flex items-center rounded-lg border border-slate-300 dark:border-slate-600 p-0.5 ${className}`}
            role='group'
            aria-label={t('nav.language')}
        >
            {(['de', 'en'] as const).map(code => (
                <button
                    key={code}
                    type='button'
                    onClick={() => setLanguage(code)}
                    aria-pressed={language === code}
                    className={`rounded-md px-2 py-0.5 text-xs font-semibold uppercase transition-colors ${
                        language === code
                            ? 'bg-indigo-700 dark:bg-indigo-600 text-white'
                            : 'text-slate-500 dark:text-slate-400 hover:text-slate-700'
                    }`}
                >
                    {code}
                </button>
            ))}
        </div>
    )
}
